import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "alert-info",
  class: "p-4 mb-4 text-primary-700 border border-primary-300 rounded-lg bg-primary-50 dark:bg-gray-800 dark:text-primary-400 dark:border-primary-800",
  role: "alert"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Dismiss", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "mt-2 mb-4 text-sm text-primary-800" }
const _hoisted_8 = { class: "flex" }

import { onMounted } from 'vue'
import { initDismisses } from 'flowbite'


export default /*#__PURE__*/_defineComponent({
  __name: 'Info',
  props: {
    title: {},
    message: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



onMounted(() => {
    initDismisses()
})

const emit = __emit

const closeAlert = () => {
    emit('close', true)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("button", {
        id: "alert-info-dismiss",
        type: "button",
        class: "ml-auto -mx-1.5 -my-1.5 bg-primary-50 text-primary-700 rounded-lg focus:ring-2 focus:ring-primary-400 p-1.5 hover:bg-primary-200 inline-flex h-8 w-8 dark:bg-primary-800 dark:text-primary-400 dark:hover:bg-primary-700",
        "data-dismiss-target": "#alert-info",
        "aria-label": "Close",
        onClick: closeAlert
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.message), 1),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "footer")
    ])
  ]))
}
}

})